// The customer site a printed QR opens: `${SCAN_SITE}/scan/{code}`.
// Set automatically – the address this app runs on (dev: localhost, production: the live domain).
// Only when the customer site lives on another domain set VITE_APP_SCAN_URL in the .env file.
export const SCAN_SITE = (import.meta.env.VITE_APP_SCAN_URL || window.location.origin).replace(/\/+$/, '');

// an old version let users type this address and kept it in the browser – a stale dev value must never reach a label
try {
  localStorage.removeItem('authx_scan_base');
} catch {
  /* storage blocked */
}
